import React from 'react';

interface GameLevel {
  id: number;
  levelNumber: number;
  levelResult: string;
  startedAt: string;
}

const GameLevels: React.FC = () => {
  const stats = [
    { label: 'Toplam Seviye', value: '1,234', change: '+12.5%', color: 'blue' },
    { label: 'Tamamlanan', value: '892', change: '+18.2%', color: 'green' },
    { label: 'Çıkılan', value: '342', change: '-5.3%', color: 'orange' },
    { label: 'Başarı Oranı', value: '72.3%', change: '+3.1%', color: 'purple' },
  ];

  const levels: GameLevel[] = [
    { id: 232769, levelNumber: 3, levelResult: 'QUIT', startedAt: 'Dec. 1, 2025, 7:28 a.m.' },
    { id: 232770, levelNumber: 5, levelResult: 'COMPLETED', startedAt: 'Dec. 1, 2025, 8:15 a.m.' },
    { id: 232771, levelNumber: 2, levelResult: 'COMPLETED', startedAt: 'Dec. 1, 2025, 9:00 a.m.' },
    { id: 232772, levelNumber: 7, levelResult: 'QUIT', startedAt: 'Dec. 1, 2025, 10:30 a.m.' },
    { id: 232773, levelNumber: 1, levelResult: 'COMPLETED', startedAt: 'Dec. 1, 2025, 11:20 a.m.' },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto space-y-6">
      <div className="mb-8">
        <h1 className="text-3xl lg:text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 dark:from-slate-200 dark:to-slate-400 bg-clip-text text-transparent mb-2">
          Game Levels
        </h1>
        <p className="text-base text-slate-600 dark:text-slate-300">Oyun seviyelerini yapılandırın ve yönetin</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 dark:border-gray-700 hover:border-purple-200 dark:hover:border-purple-600">
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm font-medium text-slate-600 dark:text-slate-300">{stat.label}</p>
              <span className={`text-xs px-2 py-1 rounded-full ${
                stat.change.startsWith('+') 
                  ? 'bg-green-100 text-green-700' 
                  : 'bg-red-100 text-red-700'
              }`}>
                {stat.change}
              </span>
            </div>
            <p className={`text-3xl font-bold bg-gradient-to-r ${
              stat.color === 'blue' ? 'from-blue-600 to-blue-400' :
              stat.color === 'green' ? 'from-green-600 to-green-400' :
              stat.color === 'purple' ? 'from-purple-600 to-purple-400' :
              'from-orange-600 to-orange-400'
            } bg-clip-text text-transparent`}>
              {stat.value}
            </p>
          </div>
        ))}
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100 dark:border-gray-700">
        <div className="px-6 py-5 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-gray-50 to-white dark:from-gray-800 dark:to-gray-800">
          <h2 className="text-xl font-semibold text-slate-800 dark:text-white">Game Levels</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-300 uppercase tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-300 uppercase tracking-wider">Seviye Numarası</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-300 uppercase tracking-wider">Seviye Sonucu</th>
                <th className="px-6 py-3 text-left text-xs font-semibold text-slate-600 dark:text-slate-300 uppercase tracking-wider">Başlangıç</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
              {levels.map((level) => (
                <tr key={level.id} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900 dark:text-white">{level.id}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-300">{level.levelNumber}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
                      level.levelResult === 'COMPLETED' 
                        ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' 
                        : 'bg-orange-100 dark:bg-orange-900 text-orange-800 dark:text-orange-200'
                    }`}>
                      {level.levelResult}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600 dark:text-slate-300">{level.startedAt}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GameLevels;

